import React from 'react';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { Divider, Header } from '@solarwindscloud/nighthawk-ui';

export const dataTestIds = {
  exportCompliance: 'export-compliance',
};

const ExportCompliance = () => (
  <UnifiedLayout
    headerText="Access Denied"
    dataTestPageName="ExportCompliance"
    dataTestId={dataTestIds.exportCompliance}
  >
    <Header textAlign="center">
      <Header.Subheader>
        This site is not available in your region.
        <Divider hidden />
        We apologize for the inconvenience, and <br />
        thank you for your interest in SolarWinds<sup>&reg;</sup>.
      </Header.Subheader>
    </Header>
  </UnifiedLayout>
);
export default ExportCompliance;
